<template>
  <BaseModal
    ref="BaseModal"
    title="Alterar Liberação"
  >
    <div class="font-weight-bold">
      Deseja realmente alterar a data de Liberação para este ticket?
    </div>
    <hr>
    <div class="mt-2">
      Data atual: <span v-text="currentDateFmt"></span>
    </div>
    <div class="mt-2 h-50">
      Nova data:
      <DateTimePicker
        v-model="newDate"
      />
    </div>
    <template v-slot:footer>
      <div class="btn btn-primary" @click="confirm()">Trocar Data</div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '../components/BaseModal'
import DateTimePicker from '../components/DateTimePicker'
import {showError} from 'hennig-common'
import moment from 'moment'

export default {
  name: 'EditNegotiatedDate',
  components: {BaseModal, DateTimePicker},
  data () {
    return {
      newDate: '',
      currentDate: ''
    }
  },
  computed: {
    currentDateFmt () {
      if (!this.currentDate) {
        return '-'
      }
      return moment(this.currentDate).format('DD/MM/YYYY HH:mm')
    }
  },
  methods: {
    show (currentDate, callback) {
      this.currentDate = currentDate
      this.newDate = currentDate
      this.$refs.BaseModal.show()
      this.callback = callback
    },
    confirm () {
      if (!this.newDate) {
        showError('Uma data precisa ser definida')
        return
      }

      this.callback({first_approval_negotiated_at: this.newDate})
      this.$refs.BaseModal.hide()
    }
  }
}
</script>

<style scoped>
::v-deep .modal-content {
    min-height: 400px;
}
</style>
